module.exports = __webpack_public_path__ + "img/24.312419c9.svg";